import styled from 'styled-components';
import { ChipStyleMixin } from 'shared/styles';

export const NewFieldAddContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 0;
  border-top: 1px solid #ececec;
  .intro {
    font-weight: 500;
    font-size: 12px;
    line-height: 14px;
    color: #7d7d7d;
  }
  .field-types {
    display: flex;
    align-items: center;
    .field-card {
      height: 32px;
      background: #ffffff;
      border: 1px solid #efefef;
      box-shadow: 0px 2px 9px rgba(22, 29, 37, 0.1);
      border-radius: 4px;
      padding: 0 10px;
      font-size: 11px;
      line-height: 13px;
      display: flex;
      align-items: center;
      color: #12344d;
      cursor: pointer;
      svg {
        margin-right: 6px;
      }
      :not(:last-child) {
        margin-right: 10px;
      }
    }
  }
  & > :not(:last-child) {
    margin-right: 16px;
  }
`;

export const CustomFieldList = styled.div<{ margin?: string }>`
  margin: ${({ margin }) => margin || '16px 0 64px 0'};
  padding: 0 32px;
  .item {
    background: #ffffff;
    box-shadow: 0px 2px 9px rgba(22, 29, 37, 0.1);
    border-radius: 6px;
    height: 50px;
    display: flex;
    padding: 0 16px;
    align-items: center;
    justify-content: space-between;
    :hover {
      .field-actions.hide {
        display: flex;
      }
    }
    .field-actions.hide {
      display: none;
    }
    .field-actions {
      display: flex;
      align-items: center;
      .divider {
        border-right: 1px solid #ececec;
        width: 1px;
        height: 24px;
      }
      .label-text {
        font-weight: 600;
        font-size: 12px;
        line-height: 20px;
        color: #475867;
        margin-left: 24px;
      }
      & > :not(:last-child) {
        margin-right: 16px;
      }
      button.dropdown-button {
        min-height: 28px;
      }
      button {
        display: flex;
        align-items: center;
        margin: 0;
        svg {
          margin-right: 8px;
        }
      }
    }
    :not(:last-child) {
      margin-bottom: 16px;
    }
  }
`;

export const DKIMData = styled.div`
  margin-top: 24px;
  padding: 20px 30px;
  width: 100%;
  background: rgb(232 234 234 / 30%);
  border-radius: 4px;
  div.dkim-header {
    display: flex;
    justify-content: space-between;
    padding-bottom: 16px;
    border-bottom: 1px solid #ececec;
    div.dkim-timestamp {
      font-size: 11px;
      color: #3c3c3c;
      opacity: 0.6;
      & > :not(:last-child) {
        margin-right: 8px;
      }
      .key {
        font-weight: 400;
      }
      .value {
        font-weight: 500;
        font-size: 12px;
      }
    }
    div.dkim-info {
      display: flex;
      margin-bottom: 8px;
      div.dkim-name {
        font-weight: 600;
        font-size: 18px;
        line-height: 20px;
        color: #12344d;
        margin-right: 8px;
      }
    }
  }
`;

export const Status = styled.div`
  ${ChipStyleMixin}
  width: fit-content;
  font-weight: 600;
  border-radius: 4px;
  &.verified {
    background: #e0f5f1;
    border: 1px solid #b4e5da;
    color: #00795b;
  }
  &.pending {
    background: #fef1e1;
    border: 1px solid #fddbb5;
    color: #c13e1b;
  }
`;

export const DKIMTableContainer = styled.div`
  overflow-x: auto;
`;

export const DKIMTable = styled.table`
  width: 100%;
  border-spacing: 4px;
  thead,
  tbody {
    width: 100%;
  }

  th {
    font-weight: 500;
    font-size: 12px;
    line-height: 14px;
    letter-spacing: 1px;
    text-transform: uppercase;
    color: #878787;
    text-align: left;
  }
  th.left {
    text-align: left;
  }
  td,
  th {
    padding: 10px 12px;
  }

  th:first-child,
  th:last-child,
  td:first-child,
  td:last-child {
    width: 10%;
  }

  div.dashed-box {
    padding: 10px 12px;
    border: 1px dashed #aac0ef;
    box-sizing: border-box;
    border-radius: 4px;
    white-space: nowrap;
  }
  td.dkim-table-data {
    font-weight: 500;
    font-size: 13px;
    line-height: 16px;
    color: #183247;
  }
`;

export const DKIMTableRow = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 16px 25px;
  background: #ffffff;
  box-shadow: 0px 2px 16px rgba(18, 52, 77, 0.1);
  border-radius: 6px;
  margin-bottom: 15px;
  flex-direction: column;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  background: #ffffff;
  width: 100%;
  justify-content: space-between;

  &.header {
    box-shadow: none;
    padding: 16px 25px;
    margin: 0;
    div {
      font-size: 15px !important;
      line-height: 14px !important;
      font-weight: 600 !important;
      // color: #989898;
    }
  }
`;

export const Col = styled.div<{ width: string; isDefault?: boolean }>`
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  color: ${({ isDefault }) => (isDefault ? '#989898' : '#12344d')};
`;

export const IconButton = styled.div`
  display: grid;
  place-content: center;
  width: 24px;
  height: 24px;
  cursor: ${({ cursor }) => cursor || 'pointer'};
`;

export const Tag = styled.div`
  ${ChipStyleMixin}
  background: #ebeff3;
  border-radius: 4px;
  font-weight: 600;
  color: #384551;
  margin: 0 6px;
`;
